import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static values = {
    draggable: { type: String, default: "[data-draggable]" }, // The element that contains position and handle
    handle: { type: String, default: "[data-handle]" },
    filter: { type: String, default: "sortable-disabled" },
    sort: { type: Boolean, default: true }
  };

  connect() {
    Sortable.create(this.element, {
      draggable: this.draggableValue,
      handle: this.handleValue,
      filter: this.filterValue,
      sort: this.sortValue,
      onUpdate: (e) => {
        let event = new CustomEvent("sortable:updated", { bubbles: true, detail: e });
        // on event received: this.element.querySelectorAll(this.positionValue).forEach((elem, index) => (elem.value = index));
        this.element.dispatchEvent(event);
      },

      // // Element is chosen
      // onChoose: (e) => {
      //   e.oldIndex;  // element index within parent
      // },

      // // Element is unchosen
      // onUnchoose: (e) => {
      //   // same properties as onEnd
      // },

      // // Element dragging started
      // onStart: (e) => {
      //   e.oldIndex;  // element index within parent
      // },

      // // Element dragging ended
      // onEnd: (e) => {
      //   var itemEl = e.item;  // dragged HTMLElement
      //   e.to;    // target list
      //   e.from;  // previous list
      //   e.oldIndex;  // element's old index within old parent
      //   e.newIndex;  // element's new index within new parent
      //   e.oldDraggableIndex; // element's old index within old parent, only counting draggable elements
      //   e.newDraggableIndex; // element's new index within new parent, only counting draggable elements
      //   e.clone // the clone element
      //   e.pullMode;  // when item is in another sortable: `"clone"` if cloning, `true` if moving
      // },

      // // Element is dropped into the list from another list
      // onAdd: (e) => {
      //   // same properties as onEnd
      // },

      // // Called by any change to the list (add / update / remove)
      // onSort: (e) => {
      //   // same properties as onEnd
      // },

      // // Element is removed from the list into another list
      // onRemove: (e) => {
      //   // same properties as onEnd
      // },

      // // Attempt to drag a filtered element
      // onFilter: (e) => {
      //   var itemEl = e.item;  // HTMLElement receiving the `mousedown|tapstart` event.
      // },

      // // Event when you move an item in the list or between lists
      // onMove: (e, originalEvent) => {
      //   // Example: https://jsbin.com/nawahef/edit?js,output
      //   e.dragged; // dragged HTMLElement
      //   e.draggedRect; // DOMRect {left, top, right, bottom}
      //   e.related; // HTMLElement on which have guided
      //   e.relatedRect; // DOMRect
      //   e.willInsertAfter; // Boolean that is true if Sortable will insert drag element after target by default
      //   originalEvent.clientY; // mouse position
      //   // return false; — for cancel
      //   // return -1; — insert before target
      //   // return 1; — insert after target
      //   // return true; — keep default insertion point based on the direction
      //   // return void; — keep default insertion point based on the direction
      // },

      // // Called when creating a clone of element
      // onClone: (e) => {
      //   var origEl = e.item;
      //   var cloneEl = e.clone;
      // },

      // // Called when dragging element changes position
      // onChange: (e) => {
      //   e.newIndex // most likely why this event is used is to get the dragging element's current index
      //   // same properties as onEnd
      // }
    });
  }
}
